import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
  FORMAT_TEXT_COMMAND,
  UNDO_COMMAND,
  REDO_COMMAND,
} from 'lexical'
import { $setBlocksType } from '@lexical/selection'
import { $createHeadingNode } from '@lexical/rich-text'
import {
  Bold,
  Italic,
  Underline,
  Undo2,
  Redo2,
  Heading2,
  Heading3,
  Link,
} from 'lucide-react'

import { InsertMenu } from './plugins/InsertMenu' // <-- NEW

const ToolbarButton = ({ onClick, children }) => (
  <button onClick={onClick} type="button" className="btn">
    {children}
  </button>
)

export function ToolbarPlugin() {
  const [editor] = useLexicalComposerContext()

  const exec = (cmd, payload = null) => editor.dispatchCommand(cmd, payload)

  const setBlockType = (type) =>
    editor.update(() => {
      const sel = $getSelection()
      if ($isRangeSelection(sel)) {
        $setBlocksType(sel, () =>
          type === 'paragraph'
            ? $createParagraphNode()
            : $createHeadingNode(type)
        )
      }
    })

  return (
    <div className="sticky top-0 z-20 flex flex-wrap items-center justify-start gap-2 bg-zinc-800 px-3 py-2 border-b border-zinc-700 md:justify-between">
      <div className="flex flex-wrap items-center gap-2">
        {/* Undo / Redo */}
        <ToolbarButton
          type="button"
          onClick={() => exec(UNDO_COMMAND)}
          title="בטל פעולה"
        >
          <Undo2 className="w-5 h-5" />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => exec(REDO_COMMAND)}
          title="בצע שוב"
        >
          <Redo2 className="w-5 h-5" />
        </ToolbarButton>

        <div className="w-px h-5 bg-zinc-600 mx-2 hidden sm:block" />

        {/* Inline styles */}
        <ToolbarButton
          type="button"
          onClick={() => exec(FORMAT_TEXT_COMMAND, 'bold')}
          title="הדגשה"
        >
          <Bold className="w-5 h-5" />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => exec(FORMAT_TEXT_COMMAND, 'italic')}
          title="נטוי"
        >
          <Italic className="w-5 h-5" />
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => exec(FORMAT_TEXT_COMMAND, 'underline')}
          title="קו תחתון"
        >
          <Underline className="w-5 h-5" />
        </ToolbarButton>

        <div className="w-px h-5 bg-zinc-600 mx-2 hidden sm:block" />

        {/* Block types */}
        <ToolbarButton
          type="button"
          onClick={() => setBlockType('paragraph')}
          title="פסקה רגילה"
        >
          <span className="font-semibold text-sm">P</span>
        </ToolbarButton>
        <ToolbarButton
          type="button"
          onClick={() => setBlockType('h2')}
          title="כותרת H2"
        >
          <Heading2 className="w-5 h-5" />
        </ToolbarButton>
        {/* <ToolbarButton
          type="button"
          onClick={() => setBlockType('h3')}
          title="כותרת H3"
        >
          <Heading3 className="w-5 h-5" />
        </ToolbarButton> */}

        <div className="w-px h-5 bg-zinc-600 mx-2 hidden sm:block" />

        {/* Link and insert */}
        <ToolbarButton
          type="button"
          onClick={() => editor.dispatchCommand('SHOW_LINK_EDITOR', null)}
          title="הוסף קישור"
        >
          <Link className="w-5 h-5" />
        </ToolbarButton>

        <InsertMenu />
      </div>
    </div>
  )
}
